import { useI18n } from "@wojo/localization";
import { UgcBlock } from "@wojo/storyblok";
import { Text } from "@wojo/ui";
import { useId } from "react";
import { useTourCodes } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import styles from "./TravelerPhotos.module.scss";

export const TravelerPhotos: React.FC = () => {
    const headingId = useId();
    const { productPage } = useI18n("productPage");

    const tourCodes = useTourCodes();
    if (!tourCodes) {
        return null;
    }

    return (
        <section
            id={TourSectionId.PHOTOS}
            tabIndex={-1}
            aria-labelledby={headingId}
            className={styles.container}
        >
            <Text.Heading
                order="3"
                tag="h2"
                id={headingId}
                style={{ paddingBottom: "var(--g-spacing-sm)" }}
            >
                {productPage.travelerPhotos.heading.l()}
            </Text.Heading>
            <UgcBlock tourCode={{ value: tourCodes }} type="productDetail" />
        </section>
    );
};
